
import { Box, Divider } from "@material-ui/core";
import moment from "moment";
import { useSnackbar } from 'notistack';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Link, Redirect } from 'react-router-dom';
import adminRoutesConstant from '../../../../constants/adminRoutesConstant';
import masterDataFormConstant from '../../../../constants/formConstants/masterDataFormConstants';
import { createOfferCode, createOfferPlan, deleteOfferCode, findOfferCodeByOfferIndentifier, findPlanById, updateOfferCode, updateOfferPlan } from '../../../../services/masterDataService';
import Button from '../../../commons/Button/Button';
import GenerateFormHook from '../../../commons/GenerateFormHook';
import PaperWrapper from '../../../commons/Paper/PaperWrapper';
import CircularProgress from '../../../commons/ProgressBar/CircularProgress';
import Text from '../../../commons/Text';

const PlanForm = ({
    match,
    readOnly = false,
    setOfferIsActive
}) => {
    const { handleSubmit, reset } = useFormContext()
    const { enqueueSnackbar } = useSnackbar();

    const { id } = match && match.params ? match.params : {};
    const [dataIsFetching, setDataIsFetching] = React.useState(false)
    const [redirect, setRedirect] = React.useState(false);
    const [btnIsLoading, setBtnIsLoading] = React.useState(false)
    const [dataById, setDataById] = React.useState({});
    const [formConst, setFormConst] = React.useState(masterDataFormConstant.forPlans(readOnly).concat())
    const [staticOfferCodeId, setStaticOfferCodeId] = React.useState('')

    const redirectToDetailsPage = () => {
        setRedirect(true);
    }

    const handleFormSubmit = (data) => {
        console.log(data, data.discount, data.discount?.length === 0);
        if (data.discount?.length === 0) {
            data.discount = null
        }
        if (data.priority.length === 0) {
            data.priority = 0
        }
        if (data.expire_at.length === 0) {
            data.is_expiry = 0
            data.expire_at = moment().format('YYYY-MM-DD').concat(' 00:00:00')
        }
        else if (data.expire_at.length > 0) {
            data.is_expiry = 1
            data.expire_at = moment(data.expire_at).format('YYYY-MM-DD').concat(' 00:00:00')
        }

        // set region id based on unit
        switch (data.unit) {
            case 'INR':
                data.region_id = 0
                break;
            case 'BDT':
                data.region_id = 1
                break;
            case 'USD':
                data.region_id = 2
                break;
            case 'GBP':
                data.region_id = 3
                break
            case 'AUD':
                data.region_id = 4
                break
            case 'CAD':
                data.region_id = 5
                break
            case 'AED':
                data.region_id = 6
                break
            case 'SGD':
                data.region_id = 7
                break
            default:
                // by default stop function execution
                return;
        }

        const defaultOfferCode = data.defaultOfferCode
        delete data.defaultOfferCode

        setBtnIsLoading(true);
        if (id) {
            if (staticOfferCodeId) {
                if (!!defaultOfferCode) {
                    updateOfferCode({
                        code: defaultOfferCode,
                    }, staticOfferCodeId).then(response => {
                        if (response) {
                            console.log('offer code updated');
                        }
                    })
                }
                else {
                    deleteOfferCode(staticOfferCodeId).then(response => {
                        if (response) {
                            console.log(staticOfferCodeId, ' offer code is deleted!');
                        }
                    })
                }
            }
            else if (!!defaultOfferCode) {
                createOfferCode({
                    code: defaultOfferCode,
                    name: data.name,
                    offer_identifier: data.offer_identifier,
                    is_static: 1
                }).then(response => {
                    if (response) {
                        console.log('static offer code created');
                    }
                })
            }

            delete dataById.defaultOfferCode;
            updateOfferPlan({
                ...dataById,
                ...data,
            }, id).then((response) => {
                redirectToDetailsPage()
                setBtnIsLoading(false);
            })
        } else {
            if (data.subtitle.length === 0) {
                data.subtitle = data.discount ? `SUBSCRIBE NOW @RS. ${data.price}/- & SAVE ${data.discount}%` : `SUBSCRIBE NOW @RS. ${data.price}/-`
            }
            if (defaultOfferCode.length > 0) {
                createOfferCode({
                    code: defaultOfferCode,
                    name: data.name,
                    offer_identifier: data.offer_identifier,
                    is_static: 1
                }).then(response => {
                    if (response) {
                        console.log('static offer code created');
                    }
                })
            }

            createOfferPlan({
                ...data
            }).then((response) => {
                redirectToDetailsPage()
                setBtnIsLoading(false);
            })
        }
    }

    const fetchDataById = (data) => {
        setDataIsFetching(true)
        findPlanById(data).then((response) => {
            if (response) {
                if (response[0]) {
                    findOfferCodeByOfferIndentifier(response[0].offer_identifier).then(offerCodeList => {
                        if (offerCodeList && offerCodeList[0]) {
                            setDataIsFetching(false)
                            reset({
                                ...response[0],
                                defaultOfferCode: offerCodeList[0].code,
                                expire_at: (response[0].is_expiry === 1) ? moment(response[0].expire_at).format('YYYY-MM-DD') : ''
                            })
                            setDataById({
                                ...response[0],
                                defaultOfferCode: offerCodeList[0].code,
                            })
                            setOfferIsActive(response[0].is_active)
                            setStaticOfferCodeId(offerCodeList[0].id)
                        }
                        else {
                            reset({
                                ...response[0],
                                expire_at: (response[0].is_expiry === 1) ? moment(response[0].expire_at).format('YYYY-MM-DD') : ''
                            })
                            setDataIsFetching(false)
                            setDataById({
                                ...response[0],
                            })
                            setOfferIsActive(response[0].is_active)
                        }
                    })
                }
            }
        });
    }

    React.useEffect(() => {
        if (id) {
            fetchDataById(id)
        }
    }, [id])

    return (
        <PaperWrapper>
            {
                dataIsFetching && <CircularProgress style={{ verticalAlign: 'middle', width: 24, height: 24 }} />
            }
            {
                !!dataById.offer_identifier && !readOnly &&
                <Link to={adminRoutesConstant.adminPaths.MailTemplateListPage.url(dataById.offer_identifier)}>
                    <Button variant='contained' color='primary' style={{ marginBottom: 16 }}>all mail templates</Button>
                </Link>
            }
            {redirect && <Redirect to={adminRoutesConstant.adminUrls.PlansDetailsScreen.url()} />}
            <Box marginBottom={2}>
                <Text fontWeight={600} fontSize={20} margin='0 0 1rem 0'>Form Hints:-</Text>
                <Text fontSize={16} margin='0 0 1rem 0'><Text fontWeight={600} component='span'>Offer Expiry Date:</Text> To make plans non-expirable leave this field blank.</Text>
                <Text fontSize={16} margin='0 0 1rem 0'><Text fontWeight={600} component='span'>Default Offer Code:</Text> It has the highest priority. If its not found then only offer codes from CSV will be used. If both are present Default Offer Code will be used!</Text>
            </Box>
            <Divider />
            <GenerateFormHook formConstant={formConst} />
            {
                !readOnly && <Button isLoading={btnIsLoading} onClick={handleSubmit(handleFormSubmit)} variant='contained' color='primary'>{id ? "Save Changes" : "Add"}</Button>
            }
        </PaperWrapper>
    )
}

export default PlanForm
